(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-hats"] && !Shopify.designMode) return;
  try {
    
  class FloatingHats extends HTMLElement {
    constructor() {
      super();
      this.hats = [];
      this.rafId = null;
      this.lastTime = 0;
      this.running = false;
      this.onResize = this.onResize.bind(this);
      this.onVisibility = this.onVisibility.bind(this);
      this.tick = this.tick.bind(this);
    }

    connectedCallback() {
      const tpl = this.querySelector('[data-stage-template]');
      const layer = this.dataset.layer || 'front';
      const opacity = parseInt(this.dataset.opacity || '100', 10) / 100;

      this.stage = document.createElement('div');
      this.stage.className = 'floating-hats-stage floating-hats-stage--' + layer;
      this.stage.setAttribute('aria-hidden', 'true');
      this.stage.style.setProperty('--floating-hats-opacity', String(opacity));
      this.stage.appendChild(tpl.content.cloneNode(true));
      document.body.appendChild(this.stage);

      const imgs = Array.from(this.stage.querySelectorAll('[data-hat]'));
      const requested = parseInt(this.dataset.hatCount || imgs.length, 10);
      const count = Math.max(1, Math.min(requested, imgs.length));

      for (let i = imgs.length - 1; i >= count; i--) {
        imgs[i].remove();
      }
      const activeImgs = imgs.slice(0, count);

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const minSize = isMobile
        ? parseInt(this.dataset.minSizeMobile || '50', 10)
        : parseInt(this.dataset.minSize || '80', 10);
      const maxSize = isMobile
        ? parseInt(this.dataset.maxSizeMobile || '110', 10)
        : parseInt(this.dataset.maxSize || '180', 10);
      const speed = isMobile
        ? parseFloat(this.dataset.speedMobile || '25')
        : parseFloat(this.dataset.speed || '60');
      const rotSpeed = isMobile
        ? parseFloat(this.dataset.rotationSpeedMobile || '25')
        : parseFloat(this.dataset.rotationSpeed || '60');

      this.updateBounds();
      const w = this.boundsW;
      const h = this.boundsH;

      this.hats = activeImgs.map((el) => {
        const size = this.rand(minSize, maxSize);
        el.style.width = size + 'px';
        el.style.height = size + 'px';
        const angle = Math.random() * Math.PI * 2;
        const v = (speed + this.rand(-speed * 0.3, speed * 0.3)) / 60;
        return {
          el,
          size,
          x: this.rand(0, Math.max(0, w - size)),
          y: this.rand(0, Math.max(0, h - size)),
          vx: Math.cos(angle) * v,
          vy: Math.sin(angle) * v,
          rot: Math.random() * 360,
          vr: this.rand(-rotSpeed, rotSpeed) / 60,
        };
      });

      this.applyTransforms();

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.reduced) {
        this.start();
      }

      window.addEventListener('resize', this.onResize);
      document.addEventListener('visibilitychange', this.onVisibility);

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.onResize);
        this.ro.observe(document.documentElement);
        this.ro.observe(document.body);
      }
    }

    disconnectedCallback() {
      this.stop();
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.ro) this.ro.disconnect();
      if (this.stage && this.stage.parentNode) {
        this.stage.parentNode.removeChild(this.stage);
      }
    }

    updateBounds() {
      const doc = document.documentElement;
      const vw = Math.max(doc.clientWidth, window.innerWidth);
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      this.boundsW = isMobile ? Math.round(vw * 1.8) : vw;
      this.boundsH = Math.max(doc.scrollHeight, doc.clientHeight, window.innerHeight);
      if (this.stage) {
        this.stage.style.height = this.boundsH + 'px';
      }
    }

    start() {
      if (this.running) return;
      this.running = true;
      this.lastTime = 0;
      this.rafId = requestAnimationFrame(this.tick);
    }

    stop() {
      this.running = false;
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    onVisibility() {
      if (document.hidden) {
        this.stop();
      } else if (!this.reduced) {
        this.start();
      }
    }

    rand(min, max) {
      return Math.random() * (max - min) + min;
    }

    onResize() {
      this.updateBounds();
      const w = this.boundsW;
      const h = this.boundsH;
      this.hats.forEach((hat) => {
        if (hat.x + hat.size > w) hat.x = Math.max(0, w - hat.size);
        if (hat.y + hat.size > h) hat.y = Math.max(0, h - hat.size);
      });
      this.applyTransforms();
    }

    tick(now) {
      if (!this.running) return;
      if (!this.lastTime) this.lastTime = now;
      const dt = Math.min(now - this.lastTime, 50);
      this.lastTime = now;

      const w = this.boundsW;
      const h = this.boundsH;

      this.hats.forEach((hat) => {
        hat.x += hat.vx * dt;
        hat.y += hat.vy * dt;
        hat.rot += hat.vr * dt;

        if (hat.x <= 0) {
          hat.x = 0;
          hat.vx = Math.abs(hat.vx);
        } else if (hat.x + hat.size >= w) {
          hat.x = w - hat.size;
          hat.vx = -Math.abs(hat.vx);
        }
        if (hat.y <= 0) {
          hat.y = 0;
          hat.vy = Math.abs(hat.vy);
        } else if (hat.y + hat.size >= h) {
          hat.y = h - hat.size;
          hat.vy = -Math.abs(hat.vy);
        }
      });

      this.applyTransforms();
      this.rafId = requestAnimationFrame(this.tick);
    }

    applyTransforms() {
      this.hats.forEach((hat) => {
        hat.el.style.transform =
          'translate3d(' + hat.x + 'px, ' + hat.y + 'px, 0) rotate(' + hat.rot + 'deg)';
      });
    }
  }

  if (!customElements.get('floating-hats')) {
    customElements.define('floating-hats', FloatingHats);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
